// extracted by mini-css-extract-plugin
export default {"root":"FormButtons_root__FAxrU","submitButton":"FormButtons_submitButton__nzWy3","saveAsDraft":"FormButtons_saveAsDraft__LMbbR","goBackButton":"FormButtons_goBackButton__K4tIu"};